import { BackgroundFitTypeEnum } from '../../components/base/BackgroundsEnum'
import { ButtonTypeEnum } from '../../constants/Enums/AccessButtonsEnum'
/**
 * @namespace StylesHelper 
 */

/**
* Helper function to generate class names based on conditions.
* @param {Object} classMap - An object where keys are class names and values are conditions.
* @returns {string} - A concatenated string of class names.
*/
export const getClassNames = (classMap) => {
  return Object.entries(classMap)
    .filter(([_, condition]) => condition) // Filter out falsy conditions
    .map(([className]) => className) // Extract class names
    .join(' '); // Join into a single string
}

const StylesHelper = {
  /**
   * Gets Access buttons button type class name 
   * @param {string } buttonType button type  
   * @returns {string}
   */
  getButtonType(buttonType) {
    switch (buttonType) {
      case `${ButtonTypeEnum.StandardWithIcon}`:
        return "standard-with-icon"
      case `${ButtonTypeEnum.OnlyText}`:
        return "only-text"
      case `${ButtonTypeEnum.OnlyIcon}`:
        return "only-icon"
      default:
        return ""
    }
  },
  /**
  * Gets background size class name based on fit type.
  * @param {Object[]} bg - An array of background objects.
  * @returns {string} - A class name based on the fit type.
  */
  getBgSize(bg) {
    switch (bg && bg.length && bg[0].fitType) {
      case BackgroundFitTypeEnum.Fit:
        return 'main-img_fit'
      case BackgroundFitTypeEnum.Fill:
        return 'main-img_fill';
      case BackgroundFitTypeEnum.Repeat:
        return 'main-img_repeat';
      default:
        break;
    }
  }

}

export default StylesHelper;

